import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule, DatePipe } from '@angular/common';
import { RouteReuseStrategy } from '@angular/router';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUIHttpModule } from 'ng-block-ui/http';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './login/login.component';
import { AuthenticationService } from './service/authentication.service';
import { HttpHelperService } from './service/helper/http/http-helper.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { WeSafeHttpInterceptor } from './service/helper/interceptor/http-interceptor-interceptor';
import { ErrorMsgComponent } from './error-msg/error-msg.component';
import { SharedModule } from './shared/shared.module';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { WorkpermitPage } from './workpermit/workpermit.page';
import { AddSignatureModal } from './workpermit/add-signature-modal/add-signature-modal.component';
import { PhotoService } from './service/helper/photo/photo.service';
import { ContractorColdWorkPermitComponent } from './contractor-cold-work-permit/contractor-cold-work-permit.component';
import { NgxAudioPlayerModule } from 'ngx-audio-player';

@NgModule({
  declarations: [AppComponent, LoginComponent, ForgetPasswordComponent, WorkpermitPage, AddSignatureModal, ContractorColdWorkPermitComponent],
  entryComponents: [AddSignatureModal],
  imports: [
    BrowserModule,
    NgxAudioPlayerModule,
    CommonModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    
    BlockUIModule.forRoot({
      message: 'Loading...'
    }),
    BlockUIHttpModule.forRoot(),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: WeSafeHttpInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, AuthenticationService, HttpHelperService, DatePipe, PhotoService],
  bootstrap: [AppComponent],
  // exports:[ErrorMsgComponent]
})
export class AppModule { }
